import axios from "axios"

function generate({}, data) {
    return axios.post("api/v1/study-missions/generate", data)
}

function regenerate({}, data) {
    return axios.post("api/v1/study-missions/regenerate", data)
}

function generateAdditional({}, data) {
    return axios.post("api/v1/study-missions/generate-additional", data)
}

function prescribe({}, data) {
    return axios.post("api/v1/study-missions/prescribe", data)
}

function unprescribe({}, data) {
    return axios.post("api/v1/study-missions/unprescribe", data)
}

export const studyMissionsService = {
    generate,
    regenerate,
    generateAdditional,
    prescribe,
    unprescribe,
}
